module.exports = __webpack_public_path__ + "img/logo_kwc.3fd9fce2.png";